import React, { createContext, useContext } from "react";

import { DropdownProps } from "semantic-ui-react";

// Context type definition
export type LocalizationContextType = {
  handleChangeLanguage: (e: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => void;
  selectedLanguage: "en" | "th";
};

export const LocalizationContext = createContext<LocalizationContextType | undefined>(undefined);

// Hook to get selected language
export const useSelectedLanguage = (): "en" | "th" => {
  const context = useContext(LocalizationContext);

  if (context === undefined) {
    throw new Error("useSelectedLanguage must be used within a LocalizationWrapper");
  }

  return context.selectedLanguage;
};

// Hook to get full localization context
export const useLocalization = (): LocalizationContextType => {
  const context = useContext(LocalizationContext);

  if (context === undefined) {
    throw new Error("useLocalization must be used within a LocalizationWrapper");
  }

  return context;
};
